import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const getConfigAllowAgentsPlaceOnHoldManual = async (): Promise<AxiosResponse> =>
  AxiosInstance.get('settings/Livechat_allow_manual_on_hold');
